export const columns: any[] = [
	{
		title: '姓名',
		align: 'center',
		dataIndex: 'name',
	},
	{
		title: '电话号码',
		align: 'center',
		dataIndex: 'mobile',
	},
	{
		title: '所在地区',
		align: 'center',
		dataIndex: 'fullDesc',
	},
	{
		title: '完成订单数',
		align: 'center',
		dataIndex: 'finishCount',
	},
]
